import CreateHealthProfileGoals from "@/view/activation/CreateHealthProfileGoals.vue";
import store from "@/store";

// Deleting an account that has no profiles left: the profile pages, where these steps normally
// are, can't be reached without a profile, so the activation screen offers them too.
const ACCOUNT_DELETION_FROM_ACTIVATION = {
    request: "activation-request-account-deletion",
    confirm: "activation-confirm-account-deletion",
    cancel: "activation-start",
};
const withAccount = () => ({ account: store.getters.account || {} });

export default [
    {
        path: "/activate",
        name: "activate",
        component: () => import("@/view/activation/ActivationKit.vue"),
        redirect: "/kit-activation/start",
    },
    {
        path: "/kit-activation",
        name: "activation",
        component: () => import("@/view/activation/ActivationKit.vue"),
        redirect: "/kit-activation/start",
        meta: {
            requiresAuth: true,
        },
        children: [
            {
                path: "start",
                name: "activation-start",
                component: () => import("@/view/activation/ActivationStart.vue")
            },
            {
                path: "delete-account",
                name: "activation-request-account-deletion",
                component: () => import("@/view/profile/DeleteAccount/RequestDeletion.vue"),
                props: withAccount,
                meta: { accountDeletion: ACCOUNT_DELETION_FROM_ACTIVATION },
            },
            {
                path: "confirm-account-deletion",
                name: "activation-confirm-account-deletion",
                component: () => import("@/view/profile/DeleteAccount/ConfirmDeletion.vue"),
                props: withAccount,
                meta: { accountDeletion: ACCOUNT_DELETION_FROM_ACTIVATION },
            },
            {
                path: "enter-code",
                name: "enter-code",
                component: () => import("@/view/activation/EnterCode.vue")
            },
            {
                path: "who-is-this-kit-for",
                name: "who-is-this-kit-for",
                component: () => import("@/view/activation/WhoIsThisKitFor.vue")
            },
            {
                path: "success",
                name: "activation-success",
                component: () => import("@/view/activation/KitActivated.vue")
            },
            {
                path: "create-health-profile-goals",
                name: "create-health-profile-goals",
                component: CreateHealthProfileGoals
            },
            {
                path: "family-networks-opt-in",
                name: "activation-family-networks-opt-in",
                component: () => import("@/view/activation/ActivationOptIn.vue")
            },
            {
                path: "family-networks-username",
                name: "activation-family-networks-username",
                component: () => import("@/view/activation/ActivationFamilyNetworksUsername.vue")
            },
            {
                path: "family-networks-avatar",
                name: "activation-family-networks-avatar",
                component: () => import("@/view/activation/ActivationFamilyNetworksAvatar.vue")
            },
            {
                path: "preparing-your-sample",
                name: "preparing-your-sample",
                component: () => import("@/view/activation/PreparingYourSample.vue")
            },
            {
                path: "completed",
                name: "activation-completed",
                component: () => import("@/view/activation/ActivationCompleted.vue")
            },
            // Epigenetics activation steps
            {
                path: "epigenetics-who-is-this-kit-for",
                name: "epigenetics-who-is-this-kit-for",
                component: () => import("@/view/activation/epigenetics/EpigeneticsWhoIsThisKitFor.vue")
            },
            {
                path: "epigenetics-avatar",
                name: "epigenetics-activation-avatar",
                component: () => import("@/view/activation/ActivationFamilyNetworksAvatar.vue")
            },
            {
                path: "epigenetics-completed",
                name: "epigenetics-activation-completed",
                component: () => import("@/view/activation/epigenetics/EpigeneticsActivationCompleted.vue")
            },
        ],
    },
    {
        path: "/upload",
        name: "upload-dna",
        component: () => import("@/view/activation/ActivationKit.vue"),
        redirect: "/upload/start",
        meta: {
            requiresAuth: false,
            referrer: true
        },
        children: [
            {
                path: "start",
                name: "upload-start",
                component: () => import("@/view/activation/upload/UploadLandingPage.vue"),
                meta: { referrer: true },
            },
            {
                path: "who-does-this-dna-belong-to",
                name: "who-does-this-dna-belong-to",
                component: () => import("@/view/activation/upload/WhoDoesThisDnaBelongsTo.vue"),
                meta: { referrer: true },
            },
            {
                path: "upload-file",
                name: "upload-file",
                component: () => import("@/view/activation/upload/UploadDnaFile.vue")
            },
            {
                path: "family-networks-opt-in",
                name: "upload-family-networks-opt-in",
                component: () => import("@/view/activation/upload/OptIn.vue")
            },
            {
                path: "family-networks-username",
                name: "upload-family-networks-username",
                component: () => import("@/view/activation/upload/FamilyNetworksUsername.vue")
            },
            {
                path: "family-networks-avatar",
                name: "upload-family-networks-avatar",
                component: () => import("@/view/activation/upload/FamilyNetworksAvatar.vue")
            },
            {
                path: "completed",
                name: "upload-completed",
                component: () => import("@/view/activation/upload/UploadCompleted.vue")
            },
        ],
    },
];
